import { GROWLER_DELIVERY_TIME } from 'utils/growlersFlow';
import type { GrowlerCartItem } from 'utils/types/GrowlerCart';
import type { GrowlerCustomer } from 'utils/types/GrowlerCustomer';
import type { OrderItem } from 'utils/types/Order';

export interface GrowlerOrderData {
  customer?: GrowlerCustomer;
  shipping?: {
    id: string;
    price: number;
    description?: string;
    deliveryTime?: string;
  };
}

export const getGrowlerItemsForPayment = (items: GrowlerCartItem[]) =>
  items.map(item => ({
    beerId: item.growler.id,
    beerName: item.growler.name,
    quantity: item.quantity,
    unit_price: item.growler.price,
    totalPrice: Math.round(item.growler.price * item.quantity * 100) / 100,
    isSubscriberPrice: false,
  }));

export const buildGrowlerOrderItems = (items: GrowlerCartItem[]): OrderItem[] =>
  items.map(item => ({
    beerId: item.growler.id,
    beerName: item.growler.name,
    brewery: item.growler.brewery,
    quantity: item.quantity,
    unitPrice: item.growler.price,
    totalPrice: Math.round(item.growler.price * item.quantity * 100) / 100,
    isSubscriberPrice: false,
  }));

export const buildGrowlerOrderPayload = ({
  userId,
  userEmail,
  items,
  subtotal,
  shippingCost,
  discount,
  cashbackRedeemed = 0,
  total,
  orderData,
  payment,
}: {
  userId: string;
  userEmail: string;
  items: OrderItem[];
  subtotal: number;
  shippingCost: number;
  discount: number;
  cashbackRedeemed?: number;
  total: number;
  orderData: GrowlerOrderData;
  payment: {
    method: 'credit_card' | 'pix';
    status: 'approved' | 'pending';
    transactionId: string | number;
    paymentId?: string | number;
    amount: number;
  };
}) => ({
  userId,
  userEmail,
  source: 'growlers',
  items,
  subtotal,
  discount,
  cashbackRedeemed,
  shippingCost,
  total,
  isSubscriber: false,
  growlerCustomer: orderData.customer,
  shipping: {
    method: 'delivery',
    cost: shippingCost,
    description:
      orderData.shipping?.description ||
      (shippingCost === 0 ? 'Entrega grátis' : 'Taxa de entrega'),
    address: {
      street:
        orderData.customer?.address?.street ||
        orderData.customer?.condominium ||
        '',
      number:
        orderData.customer?.address?.number ||
        orderData.customer?.houseNumber ||
        '',
      neighborhood: orderData.customer?.address?.neighborhood || '',
      city: orderData.customer?.address?.city || 'Araraquara',
      state: orderData.customer?.address?.uf || 'SP',
      zipCode: orderData.customer?.address?.cep || '14800-000',
      complement: orderData.customer?.address?.complement || '',
      country: 'BR',
      recipient: orderData.customer?.fullName || '',
    },
    estimatedDelivery:
      orderData.shipping?.deliveryTime || GROWLER_DELIVERY_TIME,
  },
  payment: {
    ...payment,
    currency: 'BRL',
    processedAt: new Date().toISOString(),
  },
  status: 'confirmed',
});
